import * as Yup from "yup";

export const AddOrEditMachineSchema = Yup.object().shape({
  name: Yup.string().nullable().required("machines.name-validation"),
  process_template: Yup.string()
    .nullable()
    .required("machines.process-template-validation"),
});
